import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

export const useOneOrderSelectedDisabled = () => {
  const selectedOrdersCount = useSelector(Global.selectSelectedOrdersCount) || 0;
  return selectedOrdersCount !== 1;
};
